/* eslint-disable */

import { assign } from 'xstate';
import axios from 'axios';
import {POST_MESSAGE_STATES} from "@/data/stateData";
import { sendTransitionTrackingData } from '@/utils/dashboardTracking.js';
import { validZipCodesSolar } from "@/data/validZipCodesPv";

const vlink_api_url = process.env.VUE_APP_VLINK_API_URL;
const vlink_api_token = process.env.VUE_APP_VLINK_API_TOKEN;


export const redirectParentDirectly = () => {

    // Die feste Ziel-URL, zu der das Elternfenster umgeleitet werden soll.
    const baseUrl = 'https://www.vattenfall.de/waermepumpe-anfrage-bestaetigt';

    let redirectUrl = baseUrl;

    try {
        // Dies versucht das Elternfenster umzuleiten
        window.top.location.href = redirectUrl;
    } catch (e) {
        console.error('Failed to redirect parent window directly:', e);
        // Fallback-Mechanismus, z.B. postMessage, falls Cross-Origin-Probleme auftreten
        // Denken Sie daran, '*' durch die spezifische Origin des Elternfensters zu ersetzen!
        window.parent.postMessage(
            { type: 'REDIRECT_TO_SUCCESS', url: redirectUrl },
            '*' // Beispiel: 'https://www.ihre-domain-des-elternfensters.de'
        );
    }
};

export const setStateHistory = assign(({ context, state }) => {
    const currentMachineStateName = state?.value;
    const oldToStateValue = context.toState || 'Geladen';

    return {
        ...context,
        fromState: oldToStateValue,
        toState: currentMachineStateName
    };
});

export const sendDataToGateway = async ({ context, self }) => {
    // 1. Daten holen
    const questionAnswers = context.formData;

    const gatewayUrl = process.env.VUE_APP_GATEWAY_URL;
    const surveyId = process.env.VUE_APP_SURVEY_ID;
    const item7109answer = process.env.VUE_APP_ITEM_7109_ANSWER;
    const tags = process.env.VUE_APP_TAGS;

    if (!questionAnswers) {
        self.send({
            type: 'VLINK_SUBMISSION_FAILED',
            error: { message: 'Keine Daten zum Senden vorhanden.' },
        });
        return;
    }

    // 2. Daten zusammenbauen
    const dataToSend = {
        ...questionAnswers,
        surveyId: surveyId,
        item7109answer: item7109answer,
        tags: tags,
        source: `${context.levetoSource}_${context.levetoMedium}_${context.levetoChannel}`
    };

    const MSG_DUPLICATE = 'Die eingegebenen Kontaktdaten sind bereits mit einer bestehenden Anfrage verknüpft. Bitte kontaktieren Sie unseren Kundenservice unter solutions-kundenservice@vattenfall.de oder 0800 2302300 (Mo-Fr, 9-15 Uhr; kostenlos).';
    const MSG_MISSING   = 'Ihre Daten konnten nicht verarbeitet werden. Bitte kontrollieren Sie Ihre Angaben auf Vollständigkeit oder kontaktieren Sie unseren Kundenservice unter solutions-kundenservice@vattenfall.de oder 0800 2302300 (Mo-Fr, 9-15 Uhr; kostenlos).';
    const MSG_FALLBACK  = 'Ein Fehler ist beim Senden des Kontaktformulars aufgetreten. Bitte versuchen Sie es später noch einmal oder kontaktieren Sie unseren Kundenservice unter solutions-kundenservice@vattenfall.de oder 0800 2302300 (Mo-Fr, 9-15 Uhr; kostenlos).';

    try {
        // 3. Axios POST
        const response = await axios.post(gatewayUrl, dataToSend, {
            headers: {
                'Content-Type': 'application/json',
                'X-App-Token': process.env.VUE_APP_API_TOKEN
            },
        });

        // 3.1. Erfolg
        if (response.status >= 200 && response.status < 300) {
            self.send({ type: 'VLINK_SUBMISSION_SUCCESS', payload: response.data });
            return; // Funktion hier beenden
        }

        // 3.2. Logischer Fehler (z.B. Status 400), ohne throw
        self.send({
            type: 'VLINK_SUBMISSION_FAILED',
            error: { message: MSG_FALLBACK }
        });

    } catch (error) {
        // Axios wirft bei Statuscodes außerhalb 2xx (wie 400) einen Error.
        // Wir fangen das in `error.response` ab.
        if (error.response) {
            const status = error.response.status;
            const responseData = error.response.data || {};
            const apiMessage = responseData.message || '';

            if (status === 400) {
                // FALL 2: Dubletten-Prüfung (Prüft ob "already in System" in der API-Antwort steht)
                if (apiMessage.includes('already in System')) {
                    self.send({
                        type: 'VLINK_SUBMISSION_FAILED',
                        error: { message: MSG_DUPLICATE }
                    });
                    return;
                }

                // FALL 3: Validierungsfehler / Fehlende Daten
                if (apiMessage.includes('Missing Data')) {
                    self.send({
                        type: 'VLINK_SUBMISSION_FAILED',
                        error: { message: MSG_MISSING }
                    });
                    return;
                }
            }

            // Sonstige Server-Fehler (z.B. 500er von der Bridge wegen Auth-Fehlern)
            self.send({
                type: 'VLINK_SUBMISSION_FAILED',
                error: { message: MSG_FALLBACK }
            });
        } else {
            // Netzwerkfehler / Timeout
            console.error("Gateway-Verbindungsfehler:", error);
            self.send({
                type: 'VLINK_SUBMISSION_FAILED',
                error: { message: MSG_FALLBACK }
            });
        }
    }
};

export const sendVlinkDataAction = async ({ context, self }) => {
    const dataToSend = context.formData.contactFormApiData;
    if (!dataToSend) {
        self.send({
            type: 'VLINK_SUBMISSION_FAILED',
            error: { message: 'Keine transformierten Kontaktdaten zum Senden vorhanden.' }, // Fehlerobjekt konsistent halten
        });
        return;
    }
    try {
        // **Axios POST-Anruf mit Authorization Header**
        const response = await axios.post(vlink_api_url, dataToSend, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': vlink_api_token
            },
        });

        // Prüfen, ob die API einen Erfolgscode (2xx-Bereich) zurückgibt
        if (response.status >= 200 && response.status < 300) {
            self.send({ type: 'VLINK_SUBMISSION_SUCCESS', payload: response.data });
        } else {
            console.warn('API-Antwort mit unerwartetem, aber erfolgreichem Status:', response.status, response.data);
            self.send({
                type: 'VLINK_SUBMISSION_FAILED',
                error: { message: 'Unerwarteter API-Status oder Antwortformat.' }
            });
        }

    } catch (error) {
        let errorMessage = 'Ein unbekannter Fehler ist aufgetreten.';
        let fieldErrors = {};

        if (error.response) {
            // Der Server hat mit einem Statuscode geantwortet, der außerhalb des 2xx-Bereichs liegt (z.B. 400, 401, 500)
            console.error("API-Fehler (Response):", error.response.data);
            console.error("Status:", error.response.status);

            // Spezifische Fehlerverarbeitung für Ihre 400 Bad Request Struktur
            if (error.response.data) {
                const apiErrorData = error.response.data;

                if (apiErrorData.plz && Array.isArray(apiErrorData.plz)) {
                    fieldErrors.zipCode = apiErrorData.plz[0];
                }
                if (apiErrorData.person && apiErrorData.person.mobil && Array.isArray(apiErrorData.person.mobil)) {
                    fieldErrors.phone = apiErrorData.person.mobil[0];
                }

                if (Object.keys(fieldErrors).length > 0) {
                    errorMessage = 'Bitte korrigieren Sie die markierten Felder.';
                } else if (typeof apiErrorData === 'string') {
                    errorMessage = apiErrorData;
                } else if (apiErrorData.message) {
                    errorMessage = apiErrorData.message;
                } else if (apiErrorData.error) { // Manchmal ist der Fehler in einem 'error'-Feld
                    errorMessage = apiErrorData.error;
                } else {
                    errorMessage = `Fehler vom Server (Status: ${error.response.status}).`;
                }
            } else {
                errorMessage = `Serverfehler: ${error.response.status}.`;
            }
        } else if (error.request) {
            // Die Anfrage wurde gesendet, aber es kam keine Antwort an
            console.error("API-Fehler (Request):", error.request);
            errorMessage = 'Keine Antwort vom Server erhalten. Bitte überprüfen Sie Ihre Internetverbindung.';
        } else {
            // Ein Fehler beim Einrichten der Anfrage
            console.error("API-Fehler (Message):", error.message);
            errorMessage = `Fehler bei der Anfrage: ${error.message}.`;
        }

        self.send({ type: 'VLINK_SUBMISSION_FAILED', error: { message: errorMessage, fieldErrors: fieldErrors } });
    }
};

// updateBuildingTypeData: Aktualisiert Gebäudetyp-Daten im Kontext
export const updateBuildingTypeData = assign(({ context, event }) => {
    const { value, apiDefinition, apiValue } = event.data;
    return {
        formData: {
            ...context.formData,
            building: { ...(context.formData.building || {}), type: value, }
        },
        qualifikation: {
            ...context.qualifikation,
            buildingType: { apiDefinition: apiDefinition, apiValue: apiValue, }
        }
    };
});

// updateOwnerData: Aktualisiert Eigentümer-Daten im Kontext
export const updateOwnerData = assign(({ context, event }) => {
    const { value, apiDefinition, apiValue } = event.data;
    return {
        formData: {
            ...context.formData,
            building: { ...(context.formData.building || {}), owner: value, }
        },
        qualifikation: {
            ...context.qualifikation,
            owner: { apiDefinition: apiDefinition, apiValue: apiValue, }
        }
    };
});


// updateAlreadyBuiltData: Aktualisiert Bauzustand des Gebäudes im Kontext
export const updateAlreadyBuiltData = assign(({ context, event }) => {
    const { value, apiDefinition, apiValue } = event.data;
    return {
        formData: {
            ...context.formData,
            building: { ...(context.formData.building || {}), already_built: value, }
        },
        qualifikation: {
            ...context.qualifikation,
            alreadyBuilt: { apiDefinition: apiDefinition, apiValue: apiValue, }
        }
    };
});


// updateWishPowerStorageData: Aktualisiert Wunsch nach Stromspeicher
export const updateWishPowerStorageData = assign(({ context, event }) => {
    const { value, apiDefinition, apiValue } = event.data;
    return {
        formData: {
            ...context.formData,
            building: { ...(context.formData.building || {}), wish_power_storage: value, }
        },
        qualifikation: {
            ...context.qualifikation,
            wishPowerStorage: { apiDefinition: apiDefinition, apiValue: apiValue, }
        }
    };
});

// updateWishWallboxData: Aktualisiert Wunsch nach Wallbox
export const updateWishWallboxData = assign(({ context, event }) => {
    const { value, apiDefinition, apiValue } = event.data;
    return {
        formData: {
            ...context.formData,
            building: { ...(context.formData.building || {}), wishWallbox: value, }
        },
        qualifikation: {
            ...context.qualifikation,
            wishWallbox: { apiDefinition: apiDefinition, apiValue: apiValue, }
        }
    };
});

// updateWishHeatpumpData: Aktualisiert Wunsch nach Wärmepumpe
export const updateWishHeatpumpData = assign(({ context, event }) => {
    const { value, apiDefinition, apiValue } = event.data;
    return {
        formData: {
            ...context.formData,
            building: { ...(context.formData.building || {}), wish_heatpump: value, }
        },
        qualifikation: {
            ...context.qualifikation,
            wishHeatpump: { apiDefinition: apiDefinition, apiValue: apiValue, }
        }
    };
});

export const storeZipData = assign(({ context, event }) => {
    const newBuildingData = { ...(context.formData.building || {}), zip: event.data };
    const newContactFormData = { ...(context.formData.contactForm || {}) };


    newContactFormData.zipCode = newBuildingData.zip;

    return {
        formData: {
            ...context.formData,
            building: newBuildingData,
            contactForm: newContactFormData,
        }
    };
});


export const storeAddressData = assign(({ context, event }) => {
    const prevBuilding = context?.formData?.building ?? {};
    const prevContact  = context?.formData?.contactForm ?? {};

    // event.data enthält: { zip, city, street, houseNumber }
    const payload = event?.data ?? {};
    const zip = payload.zip ?? prevBuilding.zip;
    const zipChannel = zip ? (validZipCodesSolar[String(zip)] ?? null) : null;

    const building = {
        ...prevBuilding,
        zip:         zip,
        city:        payload.city        ?? prevBuilding.city,
        street:      payload.street      ?? prevBuilding.street,
        houseNumber: payload.houseNumber ?? prevBuilding.houseNumber,
    };

    const contactForm = {
        ...prevContact,
        zipCode: building.zip,
    };

    return {
        formData: {
            ...(context.formData ?? {}),
            building,
            contactForm,
        },
        levetoChannel: zipChannel ?? context.levetoChannel,
    };
});

// updatePowerConsumersData: Aktualisiert Energieverbraucher im Kontext
export const updatePowerConsumersData = assign(({ context, event }) => {
    const { selected, apiValues, apiDefinition } = event.data;
    return {
        formData: {
            ...context.formData,
            building: { ...(context.formData.building || {}), power_consumers: selected, }
        },
        qualifikation: {
            ...context.qualifikation,
            power_consumers: { apiDefinition: apiDefinition, apiValue: apiValues, }
        }
    };
});

// storeBuildingAgeData: Speichert das Baujahr im Kontext
export const storeBuildingAgeData  = assign(({ context, event }) => {
    const { value, apiDefinition, apiValue } = event.data;
    return {
        formData: {
            ...context.formData,
            building: { ...(context.formData.building || {}), year: value, }
        },
        qualifikation: {
            ...context.qualifikation,
            buildingAge: { apiDefinition: apiDefinition, apiValue: apiValue, }
        }
    };
});






// updatePlannedReplacementData: Aktualisiert geplanter-Austausch-Daten im Kontext
export const updatePlannedReplacementData = assign(({ context, event }) => {
    const { value, apiDefinition, apiValue } = event.data;
    return {
        formData: {
            ...context.formData,
            building: { ...(context.formData.building || {}), planned_replacement: value, }
        },
        qualifikation: {
            ...context.qualifikation,
            planned_replacement: { apiDefinition: apiDefinition, apiValue: apiValue, }
        }
    };
});

export const updateAppointmentTypeData= assign(({ context, event }) => {
    const { value} = event.data;
    const vt = value === "onsite" ?  process.env.VUE_APP_ONSITE_VERTRIEBSKANAL : process.env.VUE_APP_VERTRIEBSKANAL;
    const channel = value === "onsite" ? "SH" : "ON";
    return {
        formData: {
            ...context.formData,
            building: { ...(context.formData.building || {}), appointment: value, }
        },
        vertriebskanal: vt,
        levetoChannel: channel,
    };
});


// storeContactFormData: Speichert die Rohdaten des Kontaktformulars im Kontext
export const storeContactFormData = assign({
    formData: ({ context, event }) => ({
        ...context.formData,
        contactForm: event.data,
    }),
});

// clearErrorMessage: Setzt die Fehlermeldung im Kontext zurück
export const clearErrorMessage = assign({ errorMessage: null });

export function sendTrackingPostMessage(machineState, context=null) {
    const stateInfo = POST_MESSAGE_STATES[machineState];
    if (stateInfo) {
        let screenName = stateInfo.screen_name;
        if (machineState === 'contactInformationQuestion' && context) {
            const isOnsite = context.formData?.building?.appointment === 'onsite';

            // Neuer screen_name für den Onsite-Fall
            screenName = isOnsite ? 'kontaktformular vor-ort' : 'kontaktformular online';
        }
        const message = {
            action: stateInfo.action,
            route_name: stateInfo.route_name,
            screen_number: stateInfo.screen_number,
            screen_name: screenName,
            conversion: stateInfo.conversion,
        };
        //window.parent.postMessage(message, '*');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'clickstream',
            ...message
        });
        if (process.env.NODE_ENV !== 'production') {
            console.log(process.env.NODE_ENV);
            console.log('PostMessage gesendet für (Screen View):', machineState, message);
        }
    }
}

export const trackConversion = ({ context }) => {
    // Hole die relevanten Daten aus dem Kontext
    const { fromState, fromMachineState, toMachineState, transitionCount, appSessionId } = context;

    // Rufe die Tracking-Funktion auf
    sendTransitionTrackingData(
        'conversion',
        fromState,
        'Abschluss: Formular abgesendet',
        fromMachineState,
        toMachineState,   // Ebenso der toState
        transitionCount,
        appSessionId,
    );
};